import { useEffect, useState } from 'react';
import { grams as gramsText, kcal } from '../lib/format';

// A weight field that reports a change once the user is done typing (Enter or leaving the field), or `live`.
function GramsField({ value, onChange, live, label }) {
  const [text, setText] = useState(String(Math.round(value)));
  useEffect(() => { setText(String(Math.round(value))); }, [value]);
  const commit = () => {
    const n = Number(text);
    if (n >= 1 && n <= 2000 && n !== Math.round(value)) onChange(n);
    else setText(String(Math.round(value)));
  };
  return (
    <span className="flex items-center gap-1">
      {/* Text with a number keyboard, like the app's other number fields: no spinner taking the digits' room. */}
      <input type="text" inputMode="numeric" autoComplete="off" aria-label={`Khối lượng ${label} (g)`}
        className="input tabular h-9 w-16 rounded-[10px] border-line px-2 text-right text-sm" value={text}
        onChange={(e) => {
          const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
          setText(digits);
          if (live && Number(digits) >= 1) onChange(Math.min(2000, Number(digits)));
        }}
        onBlur={commit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); } }} />
      <span className="text-xs text-muted">g</span>
    </span>
  );
}

// A meal's estimated ingredients by dish ("Thành phần ước tính"): weight, kcal and protein. With `onGrams(index,
// grams)` the weights can be corrected ("Sửa khẩu phần"): the numbers follow from the tables, no AI and no credit.
// Where the numbers come from is the SourceLine under the meal's totals, not a label per row.
export default function IngredientBreakdown({ items, onGrams, live = false }) {
  const dishes = [];
  items.forEach((item, index) => {
    const name = item.dish || '';
    const group = dishes.find((d) => d.name === name) || dishes[dishes.push({ name, rows: [] }) - 1];
    group.rows.push({ item, index });
  });
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm font-semibold">Thành phần ước tính</p>
      {dishes.map((dish) => (
        <div key={dish.name || '-'} className="rounded-[20px] border border-line px-4">
          {dish.name && <p className="pt-3 text-xs font-bold uppercase tracking-wide text-muted">{dish.name}</p>}
          <ul className="divide-y divide-line">
            {dish.rows.map(({ item, index }) => (
              <li key={index} className="flex items-center justify-between gap-3 py-2.5 text-sm">
                <span className="min-w-0">
                  <span className="block font-semibold">{item.name}</span>
                  {item.check && <span className="block text-xs font-semibold text-error">Kiểm tra lại khối lượng</span>}
                </span>
                <span className="flex shrink-0 items-center gap-3">
                  {onGrams
                    ? <GramsField value={item.grams} live={live} label={item.name} onChange={(g) => onGrams(index, g)} />
                    : <span className="tabular text-muted">{Math.round(item.grams)} g</span>}
                  <span className="tabular w-16 text-right">
                    {kcal(item.calories)} kcal
                    <span className="block text-xs text-muted">{gramsText(item.protein_g)} đạm</span>
                  </span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
